import { NgIf, NgFor, NgClass } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NumberEntryFieldComponent } from '@ifaa-components/ui-components';
import { Store } from '@ngrx/store';
import { FormArrayState } from 'ngrx-forms';
import { PensionInvestmentOptionModel } from 'src/app/model/start-a-pension-form.model';
import { InputScrollDirective } from 'src/app/modules/shared/directives/input-scroll.directive';
import { ConvertNanPipe } from 'src/app/modules/shared/pipes/convertNan';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';

@Component({
  selector: 'app-start-a-pension-investment-options',
  templateUrl: './start-a-pension-investment-options.component.html',
  styleUrls: ['./start-a-pension-investment-options.component.scss'],
  host: {
    class: 'w-100',
  },
  imports: [
    NgIf,
    NgFor,
    NumberEntryFieldComponent,
    InputScrollDirective,
    NgClass,
    ConvertNanPipe,
  ],
})
export class StartAPensionInvestmentOptionsComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  @Input() set form(value: FormArrayState<PensionInvestmentOptionModel>) {
    this.formControl = value;
  }
  @Input() set totalCount(value: number) {
    this.total = value;
  }
  @Input() set isCurrent(value: boolean) {
    this.isCurrentOptions = value;
  }

  formControl: FormArrayState<PensionInvestmentOptionModel> = null;
  total: number = null;
  isCurrentOptions: boolean = true;

  constructor(public store: Store<AppState>) {
    super();
  }
  ngOnDestroy(): void {
    super.ngOnDestroyBase();
  }

  async ngOnInit() {
    super.ngOnInitBase();
  }

  trackByFn(index, item) {
    return index;
  }
}
